import { render, staticRenderFns } from "./modalGestionCedis.vue?vue&type=template&id=e253eb92&"
import script from "./modalGestionCedis.vue?vue&type=script&lang=js&"
export * from "./modalGestionCedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports